<template>
    <div>
      <modal
        :title="$t('LateTimeExtensionModal.title')"
        @close-request="closeModal(); reinitializeModal();"
        closable
        >
  
        <table-element
          :fields="fieldsObj"
          :arrOfElement="arrOfOrder"
          :sortSpacing="1"
          :isShowFilter="true"
          :isShowSelectAll="false"
          class="card mx-2 mt-4"
        >
  
          <template #pre-body-content>
            <div class="mx-2 mb-2">
              <label>{{$t('LateTimeExtensionModal.date_picker_label')}}<span class="red-text">*</span></label>
              <regular-input
                  id="readyDate"
                  :value="spreadDate"
                  @input="updateDatePick"
                  type="date"
                  class="col-12 form-group"
                />
            </div>
  
            <create-note
              class="mb-4 mx-2"
              ref="noteCompJS"
              :title="''"
              :label="$t('LateTimeExtensionModal.reason_label')"
              :notesList="[]"
              :showCreateNoteButton="false"
              :showList="false"
              :isAllowCreateNote="true"
              :placeholder="$t('CreateNote.new_reason_title')"
            />

            <button class="btn btn-kne-orange float-right m-2" @click="applyToAll()">{{ $t('LateTimeExtensionModal.apply_to_all') }}</button>
          </template>
  
          <!-- Desktop -->
          <template #body-content-desktop="content">
            <!-- List of orders -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center"
            :class="{
            'drop': order.status === 'Drop',
            'cancel': order.status === 'Cancel',
            'waiting': order.status === 'Attente',
            'pick': order.status === 'Pick',
            'transit': order.status === 'Transit',
            'dispatch': order.status === 'Dispatch',
            'reject': order.status === 'Reject',
            'inspection': order.status === 'Inspection',
            'transfered': order.status === 'Transférée'
            }"
            :key="index">
              <td v-if="checkHistory(order.historySync)"> <button class="btn btn-kne-green" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check" /></button> </td>
              <td v-else> <button class="btn btn-kne-red" @click="onChangeDropDate(order)"><i class="fa fa-solid fa-calendar" /> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </td>
              <td>{{order.orderNumber}}</td>
              <td class="nowrap">
                <span>{{ shortenString($realName(order, 'transmitter')) || '-'}}
                  <hover-tool-tip
                    :text="`<div>${order.transmitterAddress || '-'} ${order.transmitterCity || '-'}
                              <br>${order.transmitterProvince || '-'} ${order.transmitterPostcode || '-'}, ${order.transmitterCountry || '-'}
                            </div>`"
                    :left="true"
                    :top="true"
                    clickable
                  />
                </span>
              </td>
              <td class="nowrap">
                <span>{{ shortenString($realName(order, 'receiver')) || '-'}}
                  <hover-tool-tip
                    :text="`<p>${order.receiverAddress || '-'} ${order.receiverCity || '-'}
                              <br>${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                            </p>`"
                    :left="true"
                    :top="true"
                    clickable
                  />
                </span>
              </td>
              <td>{{order.status}}</td>
              <td> 
                <regular-checkbox :id="'vehicle-ready'" :checked="order.isReady" :value="order.isReady" @change="setOrderStatus(order)"
              :label="$t('')" class="mb-2" />                  
              </td>
              <td v-if="!order.isReady">
                <regular-input
                  id="readyDate"
                  :value="order.dateSignataire"
                  @input="updateLateTime(order, $event)"
                  type="date"
                  class="col-12 form-group"
                />
                <span class="yellow_text">{{ $t('LateTimeExtensionModal.vehicle_ready_date')}}</span>
              </td>
              <td v-else-if="order.isReady && !isVehicleReadyModal">
                <regular-input
                  id="notReadyDate"
                  :min="minDate"
                  :max="maxDate"
                  :value="order.lateTime"
                  @input="($event) => updateLateTime(order, $event)"
                  type="date"
                  class="col-12 form-group"
                />
                <span class="yellow_text">{{ $t('LateTimeExtensionModal.extended_date')}}</span>
              </td>
              <td v-if="!order.isReady || !isVehicleReadyModal">
                <regular-input
                  class="mb-4 px-2"
                  :placeholder="$t('Reason for extending late time')"
                  :value="order.comment"
                  @input="updateReason(order, $event)"
                />
              </td>
              
            </tr>
          </template>
  
          <!-- Mobile -->
          <template #body-content-mobile="content">
            <!-- List of orders -->
            <div v-for="(order, index) in content.results"
            class="card my-3 mx-2"
            :class="order.status"
            :key="index">
              <div>
                <p v-if="checkHistory(order.historySync)"> <button class="btn btn-kne-green w-100" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check" /></button> </p>
                <p v-else> <button class="btn btn-kne-red" @click="onChangeDropDate(order)"><i class="fa fa-solid fa-calendar" /> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </p>
                <div class="card-header">
                  <h4>{{order.orderNumber}}</h4>
                </div>
                <p class="mx-2">{{shortenString($realName(order, 'transmitter'))}}</p>
                <p class="mx-2">{{shortenString($realName(order, 'receiver'))}}</p>
                <p class="mx-2">{{order.status}}</p>
              </div>
            </div>
          </template>
  
          <template #post-body-content>
            <div class="mt-2">
              <p class="red-text mb-0 mx-1 text-right">{{ feedbackMessage }}</p>
              <button class="btn btn-kne-orange float-right m-2" @click="onConfirm()"> {{$t('General.confirm')}} </button>
            </div>
          </template>
        </table-element>
  
        <loading-render v-if="isLoading" />
      </modal>
  
      <!-- Distributed History -->
      <distributed-history-modal
        key="distributed"
        ref="distModal"
        :isOpen="isDistributedModal"
        :priceOrderLink="priceOrderLink"
        @updateOrderInSelectedFull="(orderId, historyKey, order) => updateOrderInSelectedFull(orderId, historyKey, order)"
        @closeModal="isDistributedModal = false"
      />
    </div>
  </template>
  
  <script>
  import Modal from '../../interface-components/Modal.vue'
  import regularInput from '../../basic-components/regularInput.vue'
  import hoverToolTip from '../../basic-components/hoverToolTip.vue'
  import DistributedHistoryModal from './DistributedHistory-modal.vue'
  import DeliveryLocationModal from './DeliveryLocation-modal.vue'
  import CustomDatePick from '../Custom-packages/Custom-DatePick.vue'
  import TableElement from '../Table-component/Table-Element.vue'
  import LoadingRender from '../Other-components/LoadingRender.vue'
  import CreateNote from '../Other-components/CreateNote.vue'
  import regularCheckbox from '../../basic-components/regularCheckbox.vue'
  import { db } from '../../../../firebase'
import { publishOrderSyncRequest } from '../../../../odoo-sync-requests/order'
  
  export default {
    name: 'StatusChangeModal',
    components: {
      Modal,
      regularInput,
      hoverToolTip,
      CustomDatePick,
      DistributedHistoryModal,
      DeliveryLocationModal,
      regularCheckbox,
      TableElement,
      LoadingRender,
      CreateNote
    },
  
    props: {
      arrOfOrder: {
        type: Array,
        required: true
      },
      isOpen: Boolean,
      priceOrderLink: {
        type: Array,
        required: false
      },
      isVehicleReadyModal: {
        type: Boolean,
        required: false,
        default: false
      }
    },
  
    data () {
      return {
        date: null,
        spreadDate: null,  // Store the date from custom date picker
        spreadReason: '',
        minDate: null,
        maxDate: null,
        feedbackMessage: '',
        isDistributedModal: false,
        fieldsObj: [
         {
           text: this.$t('OrderCurrent.order'),
           type: 'orderNumber',
           value: ''
         },
         {
           text: this.$t('OrderInfo.modal.pickup.title'),
           type: 'transmitterName',
           value: ''
         },
         {
           text: this.$t('OrderInfo.modal.delivery.title'),
           type: 'receiverName',
           value: ''
         },
         {
           text: this.$t('OrderCurrent.status'),
           type: 'status',
           value: ''
         },
         {
           text: this.$t('LateTimeExtensionModal.ready'),
           type: 'ready',
           value: ''
         },
         {
           text: this.$t('OrderCurrent.date'),
           type: 'date',
           value: ''
         },
         {
           text: this.$t('OrderCurrent.reason'),
           type: 'reason',
           value: ''
         }
        ]
      }
    },
  
    created () {
      this.isLoading = false
      this.setDateRange()
    },
  
    methods: {
      setDateRange () {
        const today = new Date()
        today.setDate(today.getDate() + 1)
        const nextWeek = new Date(today)
        nextWeek.setDate(today.getDate() + 7)

        this.minDate = this.formatDate(today)
        this.maxDate = this.formatDate(nextWeek)
        this.selectedDate = this.minDate
      },
      formatDate (date) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },

      applyToAll () {
        console.log({selectedDate: this.spreadDate})
        if (!this.spreadDate) {
          this.feedbackMessage = this.$t('LateTimeExtensionModal.date_required')
          return
        }
        console.log({selectedDate: this.spreadDate})
        const note = this.$refs.noteCompJS.getNoteText()
        if (!note) {
          this.feedbackMessage = this.$t('LateTimeExtensionModal.reason_required')
          return
        }
        this.spreadReason = note

        this.arrOfOrder.forEach(order => {
          this.updateLateTime(order, this.spreadDate)
          this.updateReason(order, this.spreadReason)
        })
      },

      // Update existing updateDatePick method to store formatted date
      updateDatePick (date) {
        this.spreadDate = date
      },

      updateReason (order, newReason) {
        order.comment = newReason
      },

      async onConfirm () {
        let reasonNotFound = false
        this.arrOfOrder.forEach(async (order) => {
          if (!order.comment) {
            reasonNotFound = true
            this.feedbackMessage = this.$t('StatusChangeModal.note_error')
            return
          }
          if (!order.isReady) {
            const dateSignatairePath = db.ref('database').child(`transporter/${this.companyUID}/deliveries/${order.orderNumber}/dateSignataire`)
            await this.updateOrderFirebase(dateSignatairePath, order.dateSignataire, order.orderNumber)
          }
          const date = new Date(order.lateTime).getTime()
          const comment = order.comment
          const lateTimePath = db.ref('database').child(`transporter/${this.companyUID}/deliveries/${order.orderNumber}/lateTime`)
          const warningTimePath = db.ref('database').child(`transporter/${this.companyUID}/deliveries/${order.orderNumber}/warningTime`)
          const commentPath = db.ref('database').child(`transporter/${this.companyUID}/deliveries/${order.orderNumber}/comment`)
          await this.updateOrderFirebase(lateTimePath, date, order.orderNumber)
          await this.updateOrderFirebase(warningTimePath, date, order.orderNumber)
          await this.updateOrderFirebase(commentPath, comment, order.orderNumber)
        })
        if (!reasonNotFound) {
          await this.emitSelected()
          await this.reinitializeModal()
        }
      },

      updateLateTime (order, $event) {
        if (order.isReady) {
          order.lateTime = $event
        } else {
          const warningTime = (order.warningTime - new Date(order.dateSignataire).getTime()) / (3600 * 1000 * 24)
          const lateTime = (order.lateTime - new Date(order.dateSignataire).getTime()) / (3600 * 1000 * 24)
          order.dateSignataire = $event
          order.warningTime = new Date(warningTime + new Date(order.dateSignataire).getTime()).getTime()

          // const dateSignataire = new Date(order.dateSignataire ? this.order.dateSignataire : this.dateTemporary)
          const newWarningTime = this.addBusinessDays(order.dateSignataire, warningTime).getTime()
          const newLateTime = this.addBusinessDays(order.dateSignataire, lateTime).getTime()
          order.lateTime = newLateTime
          order.warningTime = newWarningTime

          order.comment = 'Order not ready'
        }
      },

      addBusinessDays (startDate, daysToAdd) {
      let currentDate = new Date(startDate)
      let addedDays = 0

      while (addedDays < daysToAdd) {
        currentDate.setDate(currentDate.getDate() + 1)
        const dayOfWeek = currentDate.getDay()

        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          addedDays++
        }
      }
      return currentDate
    },

    setOrderStatus (order) {
      this.$set(order, 'isReady', !order.isReady)
    },

      updateOrderFirebase (firebasePath, date, orderNumber) {
        firebasePath.set(date)
        publishOrderSyncRequest(orderNumber, this.companyUID)
      },
  
      /** Updates the order in @arrOfOrder so the button in ShortDispatch gets updated for UX purposes */
      updateOrderInSelectedFull (orderId, historyKey, updatedOrder) {
        this.arrOfOrder.find((originalOrder, index) => {
          if (originalOrder.orderNumber === orderId) {
            this.arrOfOrder[index].historySync[historyKey] = updatedOrder
          }
        })
      },
  
      /** When @dropDate or @isCancelled doesn't exist in the last history key, allow the user to set the @dropDate or @isCancelled to the last history key */
      onChangeDropDate (order) {
        const distModalRef = this.$refs.distModal
  
        const keys = distModalRef.getObjectKeys(order.historySync)
        const lastKey = distModalRef.getLastArrayData(keys)
  
        distModalRef.setOrder(order)
        distModalRef.setOrderId(order.orderNumber)
        distModalRef.setHistoryKey(lastKey)
  
        this.isDistributedModal = true
      },
  
      /** Used to set the red (false) or green (true) buttons in Short Dispatch */
      checkHistory (history) {
        return this.$refs.distModal.checkHistory(history)
      },
  
      isNoteValid (order) {
        const isNoteValid = this.$refs.noteCompJS.isNoteFilled || !order.comment
        return isNoteValid
      },
  
      isDropDateFilled () {
        let isGucci = true
  
        this.arrOfOrder.forEach(order => {
          if (!this.checkHistory(order.historySync)) isGucci = false
        })
  
        return isGucci
      },
  
      setFeedbackMessage (message) {
        this.feedbackMessage = message
      },
  
      shortenString (text) {
        if (typeof text === 'undefined') return text
        else {
          let subString = text.substring(0, 40)
          if (text.length > 40) subString += '...'
          return subString
        }
      },
  
      reinitializeModal () {
        this.date = ''
        this.feedbackMessage = ''
  
        this.closeModal()
      },
  
      emitSelected () {
        this.$emit('clearSelected')
      },
      checkOrderReady (orderReadyDate) {
        if (orderReadyDate === '') {
          return false
        }
        const today = new Date()
        const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const readyDate = new Date(orderReadyDate)
        return todayDateOnly >= readyDate
      },
  
      closeModal () {
        this.$emit('closeModal')
      }
    },

    computed: {
      companyUID () {
        return this.$store.state.authorization.company
      },
  
      uid () {
        return this.$store.state.user.uid
      }
    }
  }
  </script>

  <style>
  .active {
    opacity: 0.5;
  }
</style>
